var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-mask" }, [
    _c("div", { staticClass: "modal-wrapper" }, [
      _c("div", { staticClass: "modal_size lg_size" }, [
        _c(
          "a",
          {
            staticClass: "ui_close",
            attrs: { href: "javascript:", type: "button" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_c("span", { staticClass: "sr_only" })]
        ),
        _vm._v(" "),
        _c("dl", { staticClass: "modal_content" }, [
          _c("dt", { staticClass: "ellipsis" }, [
            _c("i", [_vm._v(_vm._s(_vm.$t("FIELD.FORWARD.TITLE")))])
          ]),
          _vm._v(" "),
          _c("dd", [
            _c("table", { staticClass: "create_table btmLine mt-20" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("tbody", [
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.INQUIRY")))]),
                  _vm._v(" "),
                  _c("td", [
                    _c("fieldset", { staticClass: "ui_fieldset set_2" }, [
                      _c("div", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inquiry1Code,
                                expression: "inquiry1Code"
                              }
                            ],
                            staticClass: "slt_white w100p",
                            attrs: { disabled: _vm.disactive },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.inquiry1Code = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function($event) {
                                  return _vm.inquiryList(2)
                                }
                              ]
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.FAST.DURATION.ALL")))
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.inquiry1CodeList, function(item) {
                              return _c(
                                "option",
                                {
                                  key: _vm.pageName + item.CD,
                                  domProps: { value: item.CD }
                                },
                                [
                                  _vm._v(
                                    "\n                                                    " +
                                      _vm._s(item.CD_NAME) +
                                      "\n                                                "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.inquiry2Code,
                                expression: "inquiry2Code"
                              }
                            ],
                            staticClass: "slt_white w100p",
                            attrs: { disabled: _vm.disactive },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.inquiry2Code = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          [
                            _c("option", { attrs: { value: "" } }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.FAST.DURATION.ALL")))
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.inquiry2CodeList, function(item) {
                              return _c(
                                "option",
                                {
                                  key: _vm.pageName + item.CD,
                                  domProps: { value: item.CD }
                                },
                                [
                                  _vm._v(
                                    "\n                                                    " +
                                      _vm._s(item.CD_NAME) +
                                      "\n                                                "
                                  )
                                ]
                              )
                            })
                          ],
                          2
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CATEGORY")))]),
                  _vm._v(" "),
                  _c("td", [
                    _c("fieldset", { staticClass: "ui_fieldset set_3" }, [
                      _c("div", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.category1Code,
                                expression: "category1Code"
                              }
                            ],
                            staticClass: "slt_white w100p",
                            attrs: { disabled: _vm.disactive },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.category1Code = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function($event) {
                                  return _vm.categoryList(2)
                                }
                              ]
                            }
                          },
                          _vm._l(_vm.category1CodeList, function(item) {
                            return _c(
                              "option",
                              {
                                key: _vm.pageName + item.code,
                                domProps: { value: item.code }
                              },
                              [
                                _vm._v(
                                  "\n                                                    " +
                                    _vm._s(item.codeName) +
                                    "\n                                                "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.category2Code,
                                expression: "category2Code"
                              }
                            ],
                            staticClass: "slt_white w100p",
                            attrs: { disabled: _vm.disactive },
                            on: {
                              change: [
                                function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.category2Code = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                                function($event) {
                                  return _vm.categoryList(3)
                                }
                              ]
                            }
                          },
                          _vm._l(_vm.category2CodeList, function(item) {
                            return _c(
                              "option",
                              {
                                key: _vm.pageName + item.code,
                                domProps: { value: item.code }
                              },
                              [
                                _vm._v(
                                  "\n                                                    " +
                                    _vm._s(item.codeName) +
                                    "\n                                                "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.category3Code,
                                expression: "category3Code"
                              }
                            ],
                            staticClass: "slt_white w100p",
                            attrs: { disabled: _vm.disactive },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.category3Code = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              }
                            }
                          },
                          _vm._l(_vm.category3CodeList, function(item) {
                            return _c(
                              "option",
                              {
                                key: _vm.pageName + item.code,
                                domProps: { value: item.code }
                              },
                              [
                                _vm._v(
                                  "\n                                                    " +
                                    _vm._s(item.codeName) +
                                    "\n                                                "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th"),
                  _vm._v(" "),
                  _c("td", { staticClass: "text_right" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn_white",
                        attrs: { href: "javascript:" },
                        on: {
                          click: function($event) {
                            _vm.disactive = false
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                                        " +
                            _vm._s(_vm.$t("FIELD.CHANGE.ANSWERER.GROUP")) +
                            "\n                                    "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    !("PQ6" === _vm.inquiry1Code && "4" === _vm.deptLevelCd) &&
                    "C720" === _vm.corpCd
                      ? _c(
                          "a",
                          {
                            staticClass: "btn_white",
                            attrs: { href: "javascript:" },
                            on: {
                              click: function($event) {
                                return _vm.addUser()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(_vm.$t("FIELD.ADMIN.ADD")) +
                                "\n                                    "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(
                      _vm._s(_vm.$t("TITLE.GLOBAL.ANSWERERS")) +
                        " (" +
                        _vm._s(_vm.getRhqName()) +
                        ")"
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "in_gird_table" }, [
                    _c(
                      "table",
                      { staticClass: "scroll_table in_table sm_grid" },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("thead", { staticClass: "text_center" }, [
                          _c("tr", [
                            _c("th", { staticClass: "normal" }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.USER.ID")))
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "normal" }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.USER.NAME")))
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "normal" }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.ADMIN.PART.NAME")))
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "normal" }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.LEVEL")))
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "normal" }, [
                              _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.EMPLOYEE.ID")))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          { staticClass: "text_center scroll height_185" },
                          _vm._l(_vm.answerList, function(answer) {
                            return _c(
                              "tr",
                              { key: _vm.pageName + answer.CHRG_USER_ID },
                              [
                                _c("td", [_vm._v(_vm._s(answer.CHRG_USER_ID))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(answer.CHRG_USER_NM))]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(answer.DEPT_NM))]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(_vm._s(answer.DEPT_LEVEL_NM))
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(answer.CHRG_USER_NO))])
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("tr", [
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("TITLE.POPUP.MESSAGE.DETAIL"))),
                    _c("em", { staticClass: "txt_mandatory" }, [_vm._v("*")])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("textarea", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.message,
                          expression: "message"
                        }
                      ],
                      staticClass: "text_textarea w100p",
                      domProps: { value: _vm.message },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.message = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("dd", { staticClass: "scroll_btm" }, [
            _c("div", { staticClass: "btn_modal_wrap mt-0" }, [
              _c("div", { staticClass: "btn_right" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn_blue",
                    attrs: { href: "javascript:" },
                    on: {
                      click: function($event) {
                        return _vm.onSave()
                      }
                    }
                  },
                  [_vm._v("Send")]
                )
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "154px" } }),
      _vm._v(" "),
      _c("col", { staticClass: "*" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "*" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "20%" } }),
      _vm._v(" "),
      _c("col", { attrs: { width: "20%" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d34acf58", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d34acf58","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/faq/popup/forwardPopup.vue
// module id = /0J6
// module chunks = 0